import { EventStatusItems } from '../models/global-view';

export class SirenConstant {
  public static GET_SIREN_DETAIL_ERROR = 'Error while receiving siren workflow details.';
  public static UPDATE_IN_PROGRESS_MSG = 'Siren settings are being applied. Please wait.';
  public static UPDATE_SUCCESS_MSG = 'Siren enabled for selected workflows on your gateway.';
  public static DISABLED_SUCCESS_MSG = 'Siren disabled for your gateway.';
  public static UPDATE_ERROR_MSG =
    'Siren enablement has failed on your gateway. This could be due to improper siren device connection / issue at your gateway.';
  public static CAMERA_DISCONNECTED_MSG = 'The operation can not be performed at this moment because camera or gateway is disconnected';
  public static sirenWorkFlowItems: EventStatusItems[] = [
    { name: 'Red zone', value: 'Red zone', checked: true },
    { name: 'PPE', value: 'PPE zone', checked: true },
    { name: 'Catwalk', value: 'Catwalk', checked: true },
    { name: 'Piperack', value: 'Piperack', checked: true },
  ];
}
